import { render } from "./EditVacancyModal.vue?vue&type=template&id=e97486e4&scoped=true"
import script from "./EditVacancyModal.vue?vue&type=script&lang=js"
export * from "./EditVacancyModal.vue?vue&type=script&lang=js"

import "./EditVacancyModal.vue?vue&type=style&index=0&id=e97486e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e97486e4"]])

export default __exports__